import React, { useEffect } from 'react';
import { MaterialUISwitch } from './styles';
import PropTypes from 'prop-types';

const DarkModeSwitch = ({ handleChange, checked }) => {
    useEffect(() => {
        const theme = checked ? 'light' : 'dark';
        const element = document.getElementById('html');
        if (element) {
            element.style.colorScheme = theme;
        }
    }, [checked]);

    return <MaterialUISwitch sx={{ m: 1 }} checked={checked} onChange={handleChange} />;
};

DarkModeSwitch.propTypes = {
    handleChange: PropTypes.func.isRequired,
    checked: PropTypes.bool.isRequired
};

DarkModeSwitch.displayName = 'DarkModeSwitch';

export default DarkModeSwitch;
